import api from '../../axios_api'
import _ from 'lodash'
import Promise from 'bluebird'
import router from '../../main'

const state = {
    server_data: [],
    archivedList: [],
    userFilters: {
        stage: true,
        sector: true,
        connections: false
    }
}

const getters = {
    userFilters: function (state) {
        return state.userFilters;
    },
    totalList: function (state, getters, rootState, rootGetters) {
        let list = state.server_data.concat(state.archivedList);
        return list;
    },
    suggestions: function (state, getters, rootState, rootGetters) {
        let data = JSON.parse(JSON.stringify(state.server_data));
        let connections = rootGetters['contacts/contactData'];
        data.map(item => {
            if (item.properties) {
                let properties = item.properties;
                item.headquarters = "";
                item.categories = "";
                item.linkedin = properties.linkedin && properties.linkedin.value ? properties.linkedin.value : '';
                item.twitter = properties.twitter && properties.twitter.value ? properties.twitter.value : '';
                item.description = properties.short_description ? properties.short_description : '';
                item.name = properties.identifier && properties.identifier.value ? properties.identifier.value : '';
                item.permalink = properties.identifier && properties.identifier.permalink ? properties.identifier.permalink : '';
                item.facebook = properties.facebook && properties.facebook.value ? properties.facebook.value : '';
                item.logo = properties.image_url ? properties.image_url : ''
                if (properties.location_identifiers && properties.location_identifiers.length > 0) {
                    properties.location_identifiers.map((locationItem, index) => {
                        item.headquarters += index == properties.location_identifiers.length - 1 ? `${locationItem.value}` : `${locationItem.value}, `
                    })
                }
                if (properties.categories && properties.categories.length > 0) {
                    properties.categories.map((categoryItem, index) => {
                        item.categories += index == properties.categories.length - 1 ? `${categoryItem.value}` : `${categoryItem.value}, `
                    })
                }
                if (item.investors && item.investors.length) {
                    item.investors.map(investorItem => {
                        let cb_uuid = investorItem.uuid.replace(/-/g, "");
                        let obj = connections.find(contact => contact.cb_uuid && contact.cb_uuid == cb_uuid);
                        if (obj) {
                            investorItem.linkedin = obj.linkedIn;
                            investorItem.facebook = obj.facebook;
                            investorItem.twitter = obj.twitter;
                            investorItem.image = obj.image;
                            investorItem.email = obj.email;
                            investorItem.investedCompanies = obj.investedCompanies;
                            investorItem.foundedCompanies = obj.foundedCompanies;
                            investorItem.master_pid = obj.master_pid;
                            investorItem.name = obj.name;
                            investorItem.num_exits = obj.num_exits;
                            investorItem.num_portfolio_organization = obj.num_portfolio_organization;
                            investorItem.phone_number = obj.phone_number;
                            investorItem.job_title = obj.job_title;
                        }
                    })
                }
            }
        })
        return data;
    },
    archivedList: function (state, getters, rootState, rootGetters) {
        return state.archivedList;
    }

}

const mutations = {
    initialize(state) {
        state.server_data = [];
        state.archivedList = [];
        state.userFilters = {
            stage: true,
            sector: true,
            connections: false
        }
    },
    suggestionsInterestedMerge(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        let list = [];
        payload.map(item => {
            let findIndex = state.archivedList.findIndex(archieveItem => archieveItem.uuid == item.uuid)
            if (findIndex && findIndex < 0) list.push(item);
        })
        payload = list;
        state.server_data = payload;
    },
    setUserFilters(state, payload) {
        state.userFilters = payload
    },
    archiveMerge(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        let list = [];
        payload.map(item => {
            let findIndex = state.server_data.findIndex(archieveItem => archieveItem.uuid == item.uuid)
            if (findIndex && findIndex < 0) list.push(item);
        })
        payload = list;
        state.archivedList = payload;
    },
    removeArchive(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        // remove the item by the id (either _id or uaid)
        state.archivedList = _.filter(state.archivedList, function (a) { return a.uuid !== payload })
    },
    removeInterested(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        // remove the item by the id (either _id or uaid)
        state.server_data = _.filter(state.server_data, function (a) { return a.uuid !== payload })
    }
}
const actions = {
    start({ state, dispatch, commit }) {
        commit('initialize')
        dispatch('getSuggestions');
    },
    stop({ commit }) {
        // clean up
        commit('initialize')
    },
    cycle({ }) { },
    getSuggestions({ commit, rootGetters, state }) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let plan;
                plan = rootGetters['workspacePlans/plan'];
                if (plan) plan = plan.toLowerCase()
                let url = `/suggestions/${plan ? plan : 'free'}/${fiifi.workspace_id}`;
                let payload = rootGetters["suggestions/userFilters"];
                if (Object.keys(payload)) {
                    payload = rootGetters["suggestions/userFilters"];
                }
                return api.post(url, { encrypt: { data: payload } })
                    .then(data => {
                        let respose = data.data.encrypt.success;
                        if (respose.archivedList) commit('archiveMerge', respose.archivedList)
                        setTimeout(() => {
                            if (respose.suggestions && respose.suggestions.length > 0) commit('suggestionsInterestedMerge', respose.suggestions)
                            else {
                                state.server_data = [];
                            }
                        }, 1000)
                        return Promise.resolve(respose)
                    })
                    .catch(err => {
                        console.error(`Error during investment fetch: ${err}`)
                        return Promise.reject(err)
                    })
            }
        }
    },
    apiArchiveSuggestion({ commit, rootGetters, dispatch, state }, payload) {
        let url = `${router.currentRoute.params.workspace_id}/archive/suggestion`
        return api.post(url, { encrypt: { data: payload } })
            .then(resp => {
                if (payload.isArchived) {
                    commit('removeArchive', payload.uuid)
                } else {
                    if (state.server_data && state.server_data.length == 1)
                        dispatch('getSuggestions');
                    commit('removeInterested', payload.uuid)
                }
                return Promise.resolve(resp.data.encrypt.success)
            })
            .catch(err => {
                console.error(`Error during investment fetch: ${err}`)
                return Promise.reject(err)
            })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}